import { PHASE_PRODUCTION_BUILD } from 'next/constants'
// This is used in getEnvs so using process here to avoid a dependency cycle
// eslint-disable-next-line regex/invalid-error
export const isBuildPhaseNotRuntime = process.env.NEXT_PHASE === PHASE_PRODUCTION_BUILD
